import React, { Fragment, useState, useEffect } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { updateDb } from "../services/updateDb";

import AlertMessage from "../common/AlertMessage";
import LoadPage from "../common/LoadPage";
import useAxiosFetch from "../common/useAxiosFetch";
import ConfirmationModal from "../common/ConfirmationModal";
import ApproveRequestModal from "./ApproveRequestModal";
import { useAppContext } from "../AppContext";
import moment from "moment";

const RequestPage = () => {
  const { currentUser, setCurrentUser, alertMessage, showAlertMessage } = useAppContext();
  const { data, loading, refetch } = useAxiosFetch("/api/requests"); //forces a refresh when risk is updated/deleted

  const [show, setShow] = useState(false);
  const [showApproval, setShowApproval] = useState(false);
  const [deleteRequest, setDeleteRequest] = useState();
  const [approveRequestObj, setApproveRequestObj] = useState();

  // remove request notifications from userObj
  useEffect(() => {
    if (currentUser.requests?.length > 0) {
      const updatedUser = { ...currentUser };
      updatedUser.requests = [];
      setCurrentUser(updatedUser);
    }
  }, [currentUser]);


  const handleClose = async (deleteRequest, reqId) => {
    setShow(false);

    if (deleteRequest && reqId) {
      const res = await updateDb("/api/requests/" + reqId, {}, "delete");

      if (res.success) {
        refetch();
        showAlertMessage('error', 'Request successfully deleted.');
      }
      else {
        showAlertMessage('error', res.error ? res.error : 'Error deleting request.');
      }
    }
  };

  const handleShow = (reqId) => {
    setDeleteRequest(reqId);
    setShow(true);
  };


  const handleShowApproval = (reqId) => {
    setApproveRequestObj(data.find((req) => req['id'] === reqId));
    setShowApproval(true);
  };

  const handleCloseApproval = async (updateRequest, reqObj) => {
    setShowApproval(false);
    if(updateRequest && reqObj) {
      const res = await updateDb("/api/requests/approve", reqObj);

      if (res.success) {
        showAlertMessage('success', 'Request approved');
        refetch();
      }
      else {
        showAlertMessage('error', res?.error);
      }
    }
  };

  if (loading)
    return <LoadPage />;

  return (
    <div id="content">

      <ConfirmationModal
        show={show}
        handleClose={handleClose}
        deleteId={deleteRequest}
      />

    <ApproveRequestModal
        show={showApproval}
        handleClose={handleCloseApproval}
        reqObj={approveRequestObj}
    />
      
      <AlertMessage type={alertMessage.type} message={alertMessage.content} />

      <div className="content-bubble content-bubble-table">

        <table className="overview-table">
          <thead>
            <tr>
              <td>Name</td>
              <td>Email</td>
              <td>Status</td>
              <td>Organization</td>
              <td>Domain</td>
              <td>Environment name</td>
              <td>Via</td>
              <td>Requested</td>
              <td width="90">&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <Fragment key={item["id"]}>
                  <tr>
                    <td className="pointer-class">{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.status}</td>
                    <td>{item.orgName}</td>
                    <td>{item.projectName}</td>
                    <td>{item.environmentName}</td>
                    <td>{item.specialEvent ? "ONE Conference" : "Website"}</td>
                    <td>{ moment(item._ts*1000).fromNow()}</td>

                    <td>
                        {item.status === 'pending' && (<i onClick={() => handleShowApproval(item.id)} className="icon-check" />)}
                        <i onClick={() => handleShow(item.id)} className="icon-delete" />
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestPage;